import { Component, OnInit, inject } from '@angular/core';
import { DateRangeValue } from '../../../../componentes/date-picker/date-picker.component';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { LuminariasHttpService } from '../../../../auxiliares/servicios/http/luminarias.service';
import {
  IFilter,
  ILogEvento,
  ILuminaria,
  IModoLuminaria,
  IPopulate,
  IQueryParam,
  IReporteGenerico,
  IReporteLuminariaGPE,
  IResumenCortesEnergiaSemana,
  IResumenDatos,
  IResumenDatosBase,
  TipoEntidad,
  TipoValoresReporte,
} from 'modelos/src';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { MatDialog } from '@angular/material/dialog';
import {
  IPieChartData,
  IBarChartData,
  ILineChartData,
  IHeatmapChartData,
} from '../../../../auxiliares/graficos/graficos.component';
import { Resumen } from '../../../../auxiliares/resumenes/resumenes.component';
import { DashboardGrillaItem } from '../../../../componentes/dashboard-grilla/dashboard-grilla.component';
import { MapaFacilData } from '../../../../auxiliares/mapa-facil/interfaces';
// import { OpenLayersService } from '../../../../auxiliares/servicios/openLayers.service'; // REMOVED: Migrated to Mapbox
import { LoginService } from '../../../login/login.service';
import {
  IResumenMensualConsumoLuminarias,
  ReportesGenericosService,
} from '../../../../auxiliares/servicios/http/reportes-genericos.service';
import { LuminariasService } from '../service';
import { firstValueFrom, Subscription } from 'rxjs';
import { ChartColors } from '../../../../auxiliares/servicios/chart-colors.service';
import { IColumnas } from '../../../../auxiliares/tabla/tabla.component';
import { DatePipe } from '@angular/common';
import {
  StatCardColor,
  StatCardConfig,
} from '../../../../componentes/stat-card/stat-card.component';
import { LogEventoLoraService } from '../../../../auxiliares/servicios/http/log-evento-lora.service';
import { ILuminariaExtendida } from '../luminarias.types';
import {
  CodigoEstadoLuminaria,
  presentacionEstado,
} from '../estado/estado-luminaria';
import { ResumenesDatosService } from '../../../../auxiliares/servicios/http/resumenes-datos.service';

interface GraficoConfig extends DashboardGrillaItem {
  titulo: string;
  /** Ícono del encabezado del panel */
  icono: string;
  /** Mensaje cuando el panel no tiene datos para mostrar */
  sinDatos?: string;
  tipo:
    | 'pie'
    | 'donut'
    | 'bar'
    | 'column'
    | 'line'
    | 'area'
    | 'heatmap'
    | 'heatmapChart'
    | 'tabla'
    | 'eventos';
  altura?: string;
  // Propiedades específicas se acceden dinámicamente desde el componente
}

// Tipado para filas de encendido diario (tabla)
interface EncendidoDetallado {
  fecha: Date;
  tiempoTotalHoras: number;
  tiempoPromedioHoras: number;
  totalDispositivos: number;
}

interface EstadosCarga {
  luminarias: boolean;
  reportes24h: boolean;
  resumenMensual: boolean;
  cortesSemana: boolean;
  ultimosUplinks: boolean;
  allUplinks: boolean;
  tasaEntrega: boolean;
  resumenDiarioEncendido: boolean;
}

interface CorteDetallado {
  idLuminaria: string;
  nombreLuminaria: string;
  cantidadCortes: number;
  horasCortada: number;
  horaUltimoCorte?: Date;
}

@Component({
  selector: 'app-dashboard-luminarias',
  templateUrl: './dashboard-luminarias.component.html',
  styleUrl: './dashboard-luminarias.component.scss',
  standalone: false,
})
export class DashboardLuminariasComponent implements OnInit {
  helper = inject(HelperService);
  matDialog = inject(MatDialog);
  luminariasService = inject(LuminariasService);
  luminariahHttpService = inject(LuminariasHttpService);
  logEventosHttpService = inject(LogEventoLoraService);
  lista2 = inject(Lista2Service);
  private reportesGenericosService = inject(ReportesGenericosService);
  private resumenesDatosService = inject(ResumenesDatosService);

  private cliente = LoginService.getClientePropio();
  public idClientePropio = this.cliente?._id;
  public statCards: StatCardConfig[] = [];
  public cargandoStatCards: boolean = true;
  public promedioConsumo?: Resumen[] = [];
  public cortesPorSemana?: IResumenCortesEnergiaSemana;

  public luminarias: ILuminariaExtendida[] = [];
  public cantidadTotalLuminarias = 0;
  public cantidadConDispositivo = 0;
  public luminariasSeleccionadas: ILuminaria[] = [];
  public modoEncendido = false;
  public hoy = new Date();
  public rangoMesesConsumo: DateRangeValue = (() => {
    const hoy = new Date();
    const inicio = new Date(hoy.getFullYear(), hoy.getMonth() - 2, 1);
    const fin = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    return { start: inicio.toISOString(), end: fin.toISOString() };
  })();
  public consumoUltimoMes?: number;
  public promedioEncendido24hs?: number;
  public promedioTasaEntregaLora?: number;
  public totalCortes24h?: number;
  public tiempoTotalCortado24h?: number;
  public reportesUltimas24Hs?: IReporteGenerico[] = [];
  public ultimosUplinks?: ILogEvento[] = [];

  // Datos detallados de cortes por luminaria
  public cortesDetallados: CorteDetallado[] = [];

  // Configuración de columnas para tabla de cortes
  public columnasCortesDetallados: IColumnas<CorteDetallado>[] = [
    {
      header: { label: 'Luminaria', sort: 'nombreLuminaria' },
      row: { field: 'nombreLuminaria' },
    },
    {
      header: { label: 'Cantidad de cortes', sort: 'cantidadCortes' },
      row: { field: 'cantidadCortes' },
    },
    {
      header: { label: 'Tiempo cortada', sort: 'horasCortada' },
      row: {
        parse: (dato: CorteDetallado) => {
          const horas = Math.floor(dato.horasCortada);
          const minutos = Math.floor((dato.horasCortada - horas) * 60);
          return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
        },
      },
    },
    {
      header: { label: 'Último corte' },
      row: {
        field: 'horaUltimoCorte',
        pipe: { pipe: DatePipe, args: 'dd/MM/yyyy HH:mm' },
      },
    },
  ];

  // Datos detallados de encendido diario (una fila por día)
  public encendidoDetallado: EncendidoDetallado[] = [];
  public columnasEncendidoDetallado: IColumnas<EncendidoDetallado>[] = [
    {
      header: { label: 'Fecha', sort: 'fecha' },
      row: { field: 'fecha', pipe: { pipe: DatePipe, args: 'dd/MM/yyyy' } },
    },
    {
      header: {
        label: 'Encendido total (h)',
        sort: 'tiempoTotalHoras',
      },
      row: {
        parse: (dato: EncendidoDetallado) => {
          const valor = Math.round(dato.tiempoTotalHoras * 100) / 100;
          return valor.toFixed(2).replace('.', ',');
        },
      },
    },
    {
      header: {
        label: 'Promedio (h)',
        sort: 'tiempoPromedioHoras',
      },
      row: {
        parse: (dato: EncendidoDetallado) => {
          const valor = Math.round(dato.tiempoPromedioHoras * 100) / 100;
          return valor.toFixed(2).replace('.', ',');
        },
      },
    },
    {
      header: { label: 'Dispositivos', sort: 'totalDispositivos' },
      row: { field: 'totalDispositivos' },
    },
  ];

  // Datos para gráficos
  public datosEstados: IPieChartData[] = [];
  public datosEncendido: IPieChartData[] = [];
  public datosModelos: IPieChartData[] = [];
  public datosDispositivos: IPieChartData[] = [];
  public datosModos: IPieChartData[] = [];
  public datosDataRate: IPieChartData[] = [];

  // Datos para gráficos de barras/columnas
  public datosConsumo: IBarChartData[] = [];
  public categoriasConsumo: string[] = [];
  public datosTiempoEncendido: IBarChartData[] = [];
  public categoriasTiempoEncendido: string[] = [];

  // Datos para heatmap de canales (frecuencias por fecha)
  public datosCanalesHeatmap?: IHeatmapChartData;
  public categoriasCanalesFechas: string[] = [];
  public categoriasCanalesFrecuencias: string[] = [];

  // Datos para gráficos de líneas
  public datosCortes: ILineChartData[] = [];
  public categoriasCortes: string[] = [];

  // Datos para heatmap geográfico de cortes
  public datosHeatmapCortes: MapaFacilData = {};

  // Configuración de gráficos ordenables
  public graficos: GraficoConfig[] = [];

  //Propiedades de carga
  public cargando: EstadosCarga = {
    luminarias: true,
    reportes24h: true,
    resumenMensual: true,
    cortesSemana: true,
    ultimosUplinks: true,
    allUplinks: true,
    tasaEntrega: true,
    resumenDiarioEncendido: true,
  };

  // Listados
  public async listar(): Promise<void> {
    try {
      this.cargando.luminarias = true;

      const filter: IFilter<{ 'ubicacion.coordinates': [number, number] }> = {
        'ubicacion.coordinates': { $exists: true, $ne: null },
      };
      const populate: IPopulate[] = [
        { path: 'modeloDispositivo', select: 'marca modelo' },
        // Mismos campos de dispositivo que usa el mapa/listado: calcularEstado
        // necesita tipo/config (offsets y frecuencia de reporte),
        // fechaUltimaComunicacion y tiempoLimiteComunicacion (estado de
        // comunicación). Se agrega paquetes.perdidaPaquetes para la tasa de entrega.
        {
          path: 'dispositivo',
          select:
            'config deveui fechaUltimaComunicacion tiempoLimiteComunicacion idModeloDispositivo name tipo paquetes.perdidaPaquetes',
        },
      ];

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        populate: JSON.stringify(populate),
        sort: 'identificacion',
        page: 0,
        includeChildren: true,
        select: `deveui identificacion idCliente idsGrupos tipoEnergizado ubicacion idModeloDispositivo estado ultimoReportePeriodico dispositivo idUltimoReporte ultimoReporteEnergia fechaUltimaComunicacion tiempoEncendida`,
      };

      const data = await this.luminariahHttpService.getFiltered(query);

      const luminarias: ILuminariaExtendida[] = data.datos;
      // Calcular estado para TODAS las luminarias (no solo las que tienen deveui).
      // calcularEstado ya devuelve E0 "Sin nodo" cuando no hay deveui/dispositivo,
      // así el total del gráfico de estados coincide con el mapa y la card.
      luminarias.forEach((l) => {
        l.estadoCalculado = this.luminariasService.determinarEstadoLuminaria(l);
      });

      this.luminarias = luminarias;
      this.cantidadTotalLuminarias = data.totalCount;
      this.cantidadConDispositivo = this.luminarias.filter(
        (lum) => lum.deveui && lum.deveui.trim() !== '',
      )?.length;
      // Procesar gráficos que dependen solo de luminarias
      this.procesarDatosGraficos();
      this.procesarDatosTiempoEncendido();
    } catch (error) {
      console.error('Error al listar luminarias:', error);
    } finally {
      this.cargando.luminarias = false;
    }
  }
  // Método unificado para consultar datos de las últimas 24 horas
  private async obtenerReportes24h() {
    try {
      this.cargando.reportes24h = true;

      const ahora = new Date();
      const hace24h = new Date(ahora.getTime() - 24 * 60 * 60 * 1000);

      const filter: IFilter<IReporteGenerico> = {
        'valores.timestamp': {
          $gte: hace24h.toISOString(),
          $lte: ahora.toISOString(),
        },
      } as any;

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        select: `
          idEntidad idsAsignados
          valores.timestamp valores.tiempoEncendida
          `,
        sort: '-valores.timestamp',
        includeChildren: true,
        unlimited: true,
      };

      const res = await firstValueFrom(
        this.lista2.reportesGenericos<
          | 'Luminaria GPE Periódico'
          | 'Luminaria Wellness'
          | 'Luminaria ACTIS FING Estado'
        >(
          [
            'Luminaria GPE Periódico',
            'Luminaria Wellness',
            'Luminaria ACTIS FING Estado',
          ],
          query,
        ),
      );
      this.reportesUltimas24Hs = res.datos;

      // Procesar datos que dependen de reportes 24h
      this.calcularPromedioEncendido();
      this.analizarCortesEnergia();
    } catch (error) {
      console.error('Error al obtener reportes 24h:', error);
    } finally {
      this.cargando.reportes24h = false;
    }
  }

  private async obtenerTasaEntrega(): Promise<void> {
    try {
      this.cargando.tasaEntrega = true;

      const tasas = this.luminarias
        .map((l) => l.dispositivo?.paquetes?.perdidaPaquetes)
        .filter((p) => p !== null && p !== undefined)
        .map((perdida) => 100 - perdida);

      if (tasas.length === 0) {
        this.promedioTasaEntregaLora = 0;
      } else {
        const promedio = tasas.reduce((acc, t) => acc + t, 0) / tasas.length;
        this.promedioTasaEntregaLora = promedio;
      }

      // No actualizar stat cards aquí, se crearán cuando el consumo esté listo
    } catch (error) {
      console.error('Error al obtener tasa de entrega:', error);
    } finally {
      this.cargando.tasaEntrega = false;
    }
  }
  private async listarCortesPorSemana(): Promise<void> {
    try {
      this.cargando.cortesSemana = true;

      const hoy = new Date();
      const unaSemanaAtras = new Date();
      unaSemanaAtras.setDate(hoy.getDate() - 7);
      unaSemanaAtras.setHours(0, 0, 0, 0);

      const filter = {
        'valores.timestamp': {
          $lte: hoy.toISOString(),
          $gte: unaSemanaAtras.toISOString(),
        },
      };

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        includeChildren: true,
      };

      this.cortesPorSemana =
        await this.reportesGenericosService.getCortesPorSemana(query);

      // Procesar gráficos de cortes
      this.procesarDatosCortes();
      this.procesarDatosHeatmapCortes();
    } catch (error) {
      console.error('Error al listar cortes por semana:', error);
    } finally {
      this.cargando.cortesSemana = false;
    }
  }

  private async listarResumensMensualConsumo(): Promise<void> {
    try {
      this.cargando.resumenMensual = true;
      const filterResumen: IFilter<IResumenDatos> = {
        tipo: 'Consumo Mensual Luminarias',
        agrupacion: 'Cliente',
        agrupacionTiempo: 'Mensual',
      };

      const queryResumen: IQueryParam = {
        filter: JSON.stringify(filterResumen),
        includeChildren: true,
      };
      const resumen: IResumenDatosBase<'Consumo Mensual Luminarias'>[] = (
        await this.resumenesDatosService.getFiltered<'Consumo Mensual Luminarias'>(
          queryResumen,
        )
      ).datos;
      // const resumen = await this.reportesGenericosService.getResumenMensual();
      this.procesarDatosConsumo(resumen);
      // Las stat cards se crearán en procesarDatosConsumo() cuando se hayan procesado todos los datos
    } catch (error) {
      console.error('Error al listar resumen mensual:', error);
    } finally {
      this.cargando.resumenMensual = false;
    }
  }

  private async listarResumensDiarioEncendido(): Promise<void> {
    try {
      this.cargando.resumenDiarioEncendido = true;
      const filterResumen: IFilter<IResumenDatos> = {
        tipo: 'Encendido Diario Luminarias',
        agrupacion: 'Cliente',
        agrupacionTiempo: 'Diario',
      };

      const queryResumen: IQueryParam = {
        filter: JSON.stringify(filterResumen),
        includeChildren: true,
      };
      const resumen: IResumenDatosBase<'Encendido Diario Luminarias'>[] = (
        await this.resumenesDatosService.getFiltered<'Encendido Diario Luminarias'>(
          queryResumen,
        )
      ).datos;
      // const resumen = await this.reportesGenericosService.getResumenMensual();
      this.procesarDatosEncendidoDiario(resumen);
      // Las stat cards se crearán en procesarDatosConsumo() cuando se hayan procesado todos los datos
    } catch (error) {
      console.error('Error al listar resumen mensual:', error);
    } finally {
      this.cargando.resumenDiarioEncendido = false;
    }
  }

  private async listarUltimosUplinks(): Promise<void> {
    try {
      this.cargando.ultimosUplinks = true;

      const deveuisLuminarias = this.luminarias.map((l) => l?.deveui);
      const filter: IFilter<ILogEvento> = {
        tipo: 'up',
        deveui: { $in: deveuisLuminarias },
      };

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        sort: '-fechaCreacion',
      };

      const data = await this.logEventosHttpService.getLastLogEventos(query);
      this.ultimosUplinks = data;
      // Procesar gráfico de data rate
      this.procesarDatosDataRate();
    } catch (error) {
      console.error('Error al listar últimos uplinks:', error);
    } finally {
      this.cargando.ultimosUplinks = false;
    }
  }

  private async listarAllUplinks() {
    try {
      this.cargando.allUplinks = true;

      const deveuisLuminarias = this.luminarias.map((l) => l?.deveui);

      const hace5Dias = new Date();
      hace5Dias.setDate(hace5Dias.getDate() - 5);
      hace5Dias.setHours(0, 0, 0, 0);

      const filter: IFilter<ILogEvento> = {
        tipo: 'up',
        deveui: { $in: deveuisLuminarias },
        fechaCreacion: { $gte: hace5Dias.toISOString() },
      } as any;

      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        sort: '-fechaCreacion',
        unlimited: true,
      };

      const data = await this.logEventosHttpService.getFiltered(query);
      this.procesarDatosCanales(data.datos);
    } catch (error) {
      console.error('Error al listar todos los uplinks:', error);
    } finally {
      this.cargando.allUplinks = false;
    }
  }

  // Procesamiento
  private calcularPromedioEncendido() {
    const reportes = this.reportesUltimas24Hs;
    // Agrupar reportes por dispositivo
    const reportesPorDispositivo: { [key: string]: IReporteGenerico[] } = {};
    for (const reporte of reportes) {
      const id = reporte.idEntidad;
      if (!reportesPorDispositivo[id]) {
        reportesPorDispositivo[id] = [];
      }
      reportesPorDispositivo[id].push(reporte);
    }

    const tiemposEncendidoPorDispositivo: Record<string, number> = {};

    // Calcular tiempo encendida por dispositivo
    for (const [idDispositivo, reportesDispositivo] of Object.entries(
      reportesPorDispositivo,
    )) {
      const reportesOrdenados = reportesDispositivo.sort(
        (a, b) =>
          new Date(a.valores.timestamp).getTime() -
          new Date(b.valores.timestamp).getTime(),
      );

      let total = 0;

      for (let i = 1; i < reportesOrdenados.length; i++) {
        const prev = Number(
          (reportesOrdenados[i - 1].valores as any)?.tiempoEncendida,
        );
        const curr = Number(
          (reportesOrdenados[i].valores as any)?.tiempoEncendida,
        );

        if (!isFinite(prev) || !isFinite(curr)) continue;

        const diff = curr - prev;
        if (diff > 0) total += diff;
      }

      tiemposEncendidoPorDispositivo[idDispositivo] = total;
    }

    // Calcular el promedio entre todos los dispositivos
    const cantidadDispositivos = Object.keys(
      tiemposEncendidoPorDispositivo,
    ).length;

    if (cantidadDispositivos === 0) {
      this.promedioEncendido24hs = 0;
    }

    const valoresEncendido = Object.values(tiemposEncendidoPorDispositivo);
    const totalEncendido = valoresEncendido.reduce(
      (acc, v) => acc + (isFinite(v) ? v : 0),
      0,
    );
    const promedio =
      cantidadDispositivos > 0 ? totalEncendido / cantidadDispositivos : 0;

    // Redondear a 2 decimales
    this.promedioEncendido24hs = Math.round(promedio * 100) / 100;
  }

  // Método para analizar cortes de energía
  private analizarCortesEnergia() {
    const reportes = this.reportesUltimas24Hs;
    const ahora = new Date();
    // Agrupar reportes por luminaria
    const reportesPorLuminaria: { [key: string]: IReporteGenerico[] } = {};
    for (const reporte of reportes) {
      const id = reporte.idsAsignados.find((id) =>
        this.luminarias.some((lum) => lum._id === id),
      );
      if (!id) {
        continue;
      }
      if (!reportesPorLuminaria[id]) {
        reportesPorLuminaria[id] = [];
      }
      reportesPorLuminaria[id].push(reporte);
    }

    let totalCortes = 0;
    let tiempoTotalCortadoMs = 0;
    const cortesDetallados: {
      idLuminaria: string;
      nombreLuminaria: string;
      cantidadCortes: number;
      horasCortada: number;
      horaUltimoCorte?: Date;
    }[] = [];

    // Analizar cortes para cada luminaria
    for (const [idLuminaria, reportesLuminaria] of Object.entries(
      reportesPorLuminaria,
    )) {
      // Ordenar por valores.timestamp (acceder como any porque timestamp puede no estar tipado)
      const reportesOrdenados = reportesLuminaria.sort((a, b) => {
        const timestampA = (a.valores as any).timestamp || a.fechaCreacion;
        const timestampB = (b.valores as any).timestamp || b.fechaCreacion;
        return new Date(timestampA).getTime() - new Date(timestampB).getTime();
      });

      let enCorte = false;
      let inicioCorte: Date | null = null;
      let cortesLuminaria = 0;
      let tiempoCortadoLuminariaMs = 0;
      let horaUltimoCorte: Date | undefined = undefined;

      for (let i = 0; i < reportesOrdenados.length; i++) {
        const reporte = reportesOrdenados[i];
        const valores = reporte.valores as any;
        const sinEnergia = valores.energiaExterna === false;
        const timestamp = valores.timestamp || reporte.fechaCreacion;

        if (sinEnergia && !enCorte) {
          // Inicio de un corte
          enCorte = true;
          inicioCorte = new Date(timestamp);
          cortesLuminaria++;
          totalCortes++;
          horaUltimoCorte = inicioCorte; // Actualizar hora del último corte
        } else if (!sinEnergia && enCorte && inicioCorte) {
          // Fin de un corte
          const finCorte = new Date(timestamp);
          const duracionCorteMs = finCorte.getTime() - inicioCorte.getTime();
          tiempoCortadoLuminariaMs += duracionCorteMs;
          tiempoTotalCortadoMs += duracionCorteMs;
          enCorte = false;
          inicioCorte = null;
        }
      }

      // Si terminó en corte, contar hasta ahora
      if (enCorte && inicioCorte) {
        const duracionCorteMs = ahora.getTime() - inicioCorte.getTime();
        tiempoCortadoLuminariaMs += duracionCorteMs;
        tiempoTotalCortadoMs += duracionCorteMs;
      }

      // Si hubo cortes en esta luminaria, agregar a la lista detallada
      if (cortesLuminaria > 0) {
        // Buscar el nombre de la luminaria
        const luminaria = this.luminarias.find(
          (lum) => lum._id === idLuminaria,
        );
        const nombreLuminaria =
          luminaria?.identificacion ||
          luminaria?.deveui ||
          `Luminaria ${idLuminaria.substring(0, 8)}`;

        const horasCortada = tiempoCortadoLuminariaMs / (1000 * 60 * 60);

        cortesDetallados.push({
          idLuminaria,
          nombreLuminaria,
          cantidadCortes: cortesLuminaria,
          horasCortada: Math.round(horasCortada * 100) / 100,
          horaUltimoCorte,
        });
      }
    }

    // Convertir tiempo total de milisegundos a horas
    const tiempoTotalCortadoHoras = tiempoTotalCortadoMs / (1000 * 60 * 60);

    // Ordenar por fecha de último corte (más reciente primero)
    cortesDetallados.sort((a, b) => {
      if (!a.horaUltimoCorte) return 1;
      if (!b.horaUltimoCorte) return -1;
      return b.horaUltimoCorte.getTime() - a.horaUltimoCorte.getTime();
    });

    const cortesData = {
      totalCortes,
      tiempoTotalCortadoHoras: Math.round(tiempoTotalCortadoHoras * 100) / 100,
      cortesDetallados,
    };

    this.totalCortes24h = cortesData.totalCortes;
    this.tiempoTotalCortado24h = cortesData.tiempoTotalCortadoHoras;
    this.cortesDetallados = cortesData.cortesDetallados;
  }

  private crearStatCards() {
    const estadoTasa = this.obtenerEstadoTasa(this.promedioTasaEntregaLora);
    this.statCards = [
      {
        title: 'Cantidad de luminarias',
        value: this.cantidadTotalLuminarias,
        subtitle: 'Total',
        icon: 'lightbulb',
        color: 'neutro',
      },
      {
        title: 'Consumo promedio diario por luminaria',
        value:
          this.consumoUltimoMes && this.cantidadConDispositivo
            ? this.consumoUltimoMes / this.cantidadConDispositivo
            : null,
        subtitle: 'kWh',
        icon: 'bolt',
        color: 'neutro',
      },
      {
        title: 'Encendido promedio diario por luminaria',
        value: this.promedioEncendido24hs,
        subtitle: 'Horas',
        icon: 'schedule',
        color: 'neutro',
      },
      {
        title: 'Tasa de entrega promedio de paquetes Lorawan',
        value: this.promedioTasaEntregaLora,
        subtitle: `% · ${estadoTasa}`,
        icon: 'cell_tower',
        color: this.tonoTasa(this.promedioTasaEntregaLora ?? 0),
      },
    ];
    this.cargandoStatCards = false;
  }

  private inicializarGraficos(): void {
    this.graficos = [
      {
        id: 'estados',
        sinDatos: 'No hay luminarias para mostrar su estado',
        icono: 'pie_chart',
        titulo: 'Distribución de estados',
        tipo: 'pie',
        altura: '320px',
      },
      {
        id: 'encendido',
        sinDatos: 'No hay información de encendido de las luminarias',
        icono: 'lightbulb',
        titulo: 'Distribución encendidas/apagadas',
        tipo: 'pie',
        altura: '320px',
      },
      {
        id: 'modelos',
        sinDatos: 'No hay luminarias para mostrar sus modelos',
        icono: 'memory',
        titulo: 'Modelos',
        tipo: 'pie',
        altura: '320px',
      },
      {
        id: 'dispositivos',
        sinDatos: 'No hay luminarias para mostrar',
        icono: 'router',
        titulo: 'Luminarias con/sin dispositivo',
        tipo: 'pie',
        altura: '320px',
      },
      {
        id: 'modos',
        sinDatos: 'No hay información del modo de las luminarias',
        icono: 'settings_suggest',
        titulo: 'Distribución por modo',
        tipo: 'pie',
        altura: '320px',
      },
      {
        id: 'eventosAlarma',
        icono: 'report',
        titulo: 'Eventos por tipo de alarma',
        tipo: 'eventos',
        altura: '320px',
      },
      {
        id: 'dataRate',
        sinDatos: 'No hay uplinks recientes para calcular el data rate',
        icono: 'speed',
        titulo: 'Distribución por data rate de últimos uplinks',
        tipo: 'pie',
        altura: '320px',
      },
      {
        id: 'consumo',
        sinDatos: 'No hay consumo registrado en el período elegido',
        icono: 'bolt',
        titulo: 'Consumo mensual',
        tipo: 'column',
        altura: '300px',
      },
      {
        id: 'canales',
        sinDatos: 'No hay uplinks para mostrar la distribución de canales',
        icono: 'settings_input_antenna',
        titulo: 'Distribución de canales de uplinks',
        tipo: 'heatmapChart',
        altura: '350px',
      },
      {
        id: 'tiempoEncendido',
        sinDatos: 'No hay información de horas de encendido',
        icono: 'highlight',
        titulo: 'Luminarias según tiempo de encendido',
        tipo: 'bar',
        altura: '300px',
      },
      {
        id: 'cortes',
        sinDatos: 'No se registraron cortes de energía en la última semana',
        icono: 'power_off',
        titulo: 'Cortes de energía por día (última semana)',
        tipo: 'line',
        altura: '300px',
      },
      {
        id: 'cortesDetallados',
        icono: 'electric_bolt',
        titulo: 'Detalle de cortes por luminaria (últimas 24 h)',
        tipo: 'tabla',
        altura: 'auto',
      },
      {
        id: 'encendidoDetallado',
        icono: 'highlight',
        titulo: 'Detalle de tiempo de encendido diario',
        tipo: 'tabla',
        altura: 'auto',
      },
      {
        id: 'heatmapCortes',
        sinDatos: 'No hubo cortes de energía para ubicar en el mapa',
        icono: 'map',
        titulo: 'Mapa de calor de cortes de energía',
        tipo: 'heatmap',
        altura: '320px',
      },
    ];
  }

  public graficoListo(id: string): boolean {
    switch (id) {
      case 'estados':
      case 'encendido':
      case 'modelos':
      case 'dispositivos':
      case 'modos':
      case 'tiempoEncendido':
        return !this.cargando.luminarias;
      case 'consumo':
        return !this.cargando.resumenMensual;
      case 'cortes':
      case 'heatmapCortes':
        return !this.cargando.cortesSemana;
      case 'cortesDetallados':
        return !this.cargando.reportes24h;
      case 'encendidoDetallado':
        return !this.cargando.resumenDiarioEncendido;
      case 'dataRate':
        return !this.cargando.ultimosUplinks;
      case 'canales':
        return !this.cargando.allUplinks;
      default:
        return true;
    }
  }

  public statCardsListas(): boolean {
    return (
      !this.cargando.luminarias &&
      !this.cargando.resumenMensual &&
      !this.cargando.reportes24h &&
      !this.cargando.tasaEntrega
    );
  }

  private actualizarStatCards() {
    const estadoTasa = this.obtenerEstadoTasa(
      this.promedioTasaEntregaLora ?? 0,
    );

    this.statCards = [
      {
        title: 'Cantidad de luminarias',
        value: this.cantidadTotalLuminarias,
        subtitle: 'Total',
        icon: 'lightbulb',
        color: 'neutro',
      },
      {
        title: 'Consumo promedio diario por luminaria',
        value:
          this.consumoUltimoMes && this.cantidadConDispositivo
            ? this.consumoUltimoMes / this.cantidadConDispositivo
            : null,
        subtitle: 'kWh',
        icon: 'bolt',
        color: 'neutro',
      },
      {
        title: 'Encendido promedio por luminaria últimas 24 hs',
        value: this.promedioEncendido24hs,
        subtitle: 'Horas',
        icon: 'schedule',
        color: 'neutro',
      },
      {
        title: 'Tasa de entrega promedio de paquetes Lorawan',
        value: this.promedioTasaEntregaLora,
        subtitle: `% · ${estadoTasa}`,
        icon: 'cell_tower',
        color: this.tonoTasa(this.promedioTasaEntregaLora ?? 0),
      },
    ];
    if (this.statCardsListas()) {
      this.cargandoStatCards = false;
    }
  }

  public obtenerDatosGrafico(id: string): any {
    switch (id) {
      case 'estados':
        return this.datosEstados;
      case 'encendido':
        return this.datosEncendido;
      case 'modelos':
        return this.datosModelos;
      case 'dispositivos':
        return this.datosDispositivos;
      case 'modos':
        return this.datosModos;
      case 'consumo':
        return this.datosConsumo;
      case 'tiempoEncendido':
        return this.datosTiempoEncendido;
      case 'dataRate':
        return this.datosDataRate;
      case 'cortes':
        return this.datosCortes;
      case 'cortesDetallados':
        return this.cortesDetallados;
      case 'encendidoDetallado':
        return this.encendidoDetallado;
      case 'heatmapCortes':
        return this.datosHeatmapCortes;
      default:
        return [];
    }
  }

  /**
   * Si el panel tiene algo que mostrar. Sin datos se muestra el mensaje del
   * panel en lugar de un gráfico vacío. "Sin dato" no cuenta como dato.
   */
  public tieneDatos(grafico: GraficoConfig): boolean {
    const hayValor = (v: number | [number, number]) =>
      (Array.isArray(v) ? v[1] : v) > 0;
    switch (grafico.tipo) {
      case 'pie':
      case 'donut':
        return (this.obtenerDatosGrafico(grafico.id) as IPieChartData[])?.some(
          (d) => d.y > 0 && d.name !== 'Sin dato',
        );
      case 'bar':
      case 'column':
      case 'line':
        return (
          this.obtenerDatosGrafico(grafico.id) as (
            | IBarChartData
            | ILineChartData
          )[]
        )?.some((serie) =>
          (serie.data as (number | [number, number])[])?.some(hayValor),
        );
      case 'heatmapChart':
        return !!this.datosCanalesHeatmap?.data?.length;
      case 'heatmap':
        return !!this.datosHeatmapCortes?.heatmaps?.length;
      default:
        // Las tablas y los eventos muestran su propio estado vacío
        return true;
    }
  }

  public obtenerCategoriasGrafico(id: string): string[] | undefined {
    switch (id) {
      case 'consumo':
        return this.categoriasConsumo;
      case 'tiempoEncendido':
        return this.categoriasTiempoEncendido;
      case 'cortes':
        return this.categoriasCortes;
      default:
        return undefined;
    }
  }

  private tonoTasa(tasaEntrega: number): StatCardColor {
    if (tasaEntrega >= 95) return 'success';
    if (tasaEntrega >= 80) return 'warning';
    return 'error';
  }

  private obtenerEstadoTasa(tasaEntrega: number): string {
    if (tasaEntrega >= 95) {
      return 'Excelente';
    } else if (tasaEntrega >= 80) {
      return 'Aceptable';
    } else {
      return 'Crítico';
    }
  }

  private procesarDatosGraficos(): void {
    this.procesarDatosEstados();
    this.procesarDatosEncendido();
    this.procesarDatosModelos();
    this.procesarDatosDispositivos();
    this.procesarDatosModos();
    this.procesarDatosDataRate();
  }

  private procesarDatosEstados(): void {
    const codigos: CodigoEstadoLuminaria[] = [0, 1, 2, 3, 4, 5];
    const conteo: Record<number, number> = {
      0: 0,
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    };
    this.luminarias.forEach((l) => {
      const codigo = l.estadoCalculado?.codigo;
      if (codigo != null) conteo[codigo]++;
    });
    this.datosEstados = codigos
      .map((c) => ({
        name: presentacionEstado(c).label,
        y: conteo[c],
        color: presentacionEstado(c).color,
      }))
      .filter((d) => d.y > 0);
  }

  private procesarDatosEncendido(): void {
    let encendidas = 0;
    let apagadas = 0;
    let sinDato = 0;
    this.luminarias.forEach((l) => {
      const encendida = this.luminariasService.isEncendida(l);
      if (encendida === true) encendidas++;
      else if (encendida === false) apagadas++;
      else sinDato++;
    });
    this.datosEncendido = [
      { name: 'Encendida', y: encendidas, color: presentacionEstado(4).color },
      { name: 'Apagada', y: apagadas, color: presentacionEstado(5).color },
      { name: 'Sin dato', y: sinDato, color: ChartColors.neutral() },
    ].filter((d) => d.y > 0);
  }

  private procesarDatosModelos(): void {
    const conteoModelos: Record<string, number> = {};

    this.luminarias.forEach((lum) => {
      const marca = lum.modeloDispositivo?.marca ?? 'Sin marca';
      const modelo = lum.modeloDispositivo?.modelo ?? 'Sin modelo';
      const nombreModelo = `${marca} ${modelo}`;

      if (!conteoModelos[nombreModelo]) {
        conteoModelos[nombreModelo] = 0;
      }
      conteoModelos[nombreModelo]++;
    });

    this.datosModelos = Object.entries(conteoModelos).map(
      ([modelo, cantidad], index) => ({
        name: modelo,
        y: cantidad,
        color: ChartColors.getCategoricalByIndex(index),
      }),
    );
  }

  private procesarDatosDataRate(): void {
    const conteoDR: Record<number, number> = {};

    // Filtrar solo los uplinks que tienen metadatos y DR
    this.ultimosUplinks?.forEach((uplink) => {
      const dr = uplink.metadatosUplink?.dr;
      if (dr !== undefined && dr !== null) {
        if (!conteoDR[dr]) {
          conteoDR[dr] = 0;
        }
        conteoDR[dr]++;
      }
    });

    this.datosDataRate = Object.entries(conteoDR)
      .map(([dr, cantidad]) => ({
        name: `DR${dr}`,
        y: cantidad,
        dr: Number(dr),
      }))
      .sort((a, b) => a.dr - b.dr)
      .map((item, index) => ({
        name: item.name,
        y: item.y,
        color: ChartColors.getCategoricalByIndex(index),
      }));
  }

  private procesarDatosDispositivos(): void {
    const coloresPorEstado: Record<string, string> = {
      'Con dispositivo': ChartColors.success(),
      'Sin dispositivo': ChartColors.sinDispositivo(),
    };

    const conteo = {
      conDispositivo: 0,
      sinDispositivo: 0,
    };

    this.luminarias.forEach((lum) => {
      if (lum.deveui && lum.deveui.trim() !== '') {
        conteo.conDispositivo++;
      } else {
        conteo.sinDispositivo++;
      }
    });

    this.datosDispositivos = [
      {
        name: 'Con dispositivo',
        y: conteo.conDispositivo,
        color: coloresPorEstado['Con dispositivo'],
      },
      {
        name: 'Sin dispositivo',
        y: conteo.sinDispositivo,
        color: coloresPorEstado['Sin dispositivo'],
      },
    ];
  }

  private procesarDatosModos(): void {
    // Todos los modos posibles de IModoLuminaria + "Sin dato" para las
    // luminarias sin reporte periódico (antes sólo se contaban 3 modos, por eso
    // el gráfico no consideraba Indeterminado/Por Defecto ni las sin reporte).
    const SIN_DATO = 'Sin dato';
    const coloresPorModo: Record<string, string> = {
      Astronómico: ChartColors.info(), // Azul
      Fotocélula: ChartColors.warning(), // Naranja
      Manual: ChartColors.color4(), // Púrpura
      'Por Defecto': ChartColors.success(),
      Indeterminado: ChartColors.error(),
      [SIN_DATO]: ChartColors.neutral(),
    };

    const modos: IModoLuminaria[] = [
      'Astronómico',
      'Fotocélula',
      'Manual',
      'Por Defecto',
      'Indeterminado',
    ];
    const conteoModos: Record<string, number> = {};
    modos.forEach((m) => (conteoModos[m] = 0));
    conteoModos[SIN_DATO] = 0;

    this.luminarias.forEach((l) => {
      const modo = l.ultimoReportePeriodico?.valores?.modo;
      if (modo && conteoModos[modo] !== undefined) {
        conteoModos[modo]++;
      } else {
        conteoModos[SIN_DATO]++;
      }
    });

    this.datosModos = Object.entries(conteoModos)
      .map(([modo, cantidad]) => ({
        name: modo,
        y: cantidad,
        color: coloresPorModo[modo] ?? ChartColors.getCategoricalByIndex(0),
      }))
      .filter((d) => d.y > 0);
  }

  private procesarDatosEncendidoDiario(
    resumenDiario: IResumenDatosBase<'Encendido Diario Luminarias'>[],
  ): void {
    // Generar filas por día agregando resultados (cliente + hijos)
    if (!resumenDiario || resumenDiario.length === 0) {
      this.encendidoDetallado = [];
      this.promedioEncendido24hs = 0;
      if (this.statCardsListas()) this.actualizarStatCards();
      return;
    }

    const agregados = new Map<
      string,
      {
        totalHoras: number;
        totalDispositivos: number;
        promedioHorasPonderado: number;
      }
    >();

    for (const item of resumenDiario) {
      const fechaBase = new Date(
        item.periodoInicio ?? item.fechaCreacion ?? new Date().toISOString(),
      );
      const key = `${fechaBase.getFullYear()}-${(fechaBase.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${fechaBase.getDate().toString().padStart(2, '0')}`; // YYYY-MM-DD

      const total = item.resumen?.tiempoEncendidoTotal ?? 0;
      const dispositivos = item.resumen?.totalDispositivos ?? 0;
      const promedio = item.resumen?.tiempoEncendidoPromedio ?? 0;

      const actual = agregados.get(key) ?? {
        totalHoras: 0,
        totalDispositivos: 0,
        promedioHorasPonderado: 0,
      };

      actual.totalHoras += total;
      actual.totalDispositivos += dispositivos;
      actual.promedioHorasPonderado += promedio * dispositivos; // promedio ponderado por cantidad de dispositivos
      agregados.set(key, actual);
    }

    const filas: EncendidoDetallado[] = Array.from(agregados.entries())
      .map(([key, val]) => {
        const [yy, mm, dd] = key.split('-').map((v) => parseInt(v, 10));
        const promedioHoras =
          val.totalDispositivos > 0
            ? val.promedioHorasPonderado / val.totalDispositivos
            : 0;
        return {
          fecha: new Date(yy, mm - 1, dd),
          tiempoTotalHoras: Math.round(val.totalHoras * 100) / 100,
          tiempoPromedioHoras: Math.round(promedioHoras * 100) / 100,
          totalDispositivos: val.totalDispositivos,
        } as EncendidoDetallado;
      })
      .sort((a, b) => b.fecha.getTime() - a.fecha.getTime());

    this.encendidoDetallado = filas;

    // Usar el día más reciente para alimentar la stat card de promedio
    const masReciente = this.encendidoDetallado[0];
    this.promedioEncendido24hs = masReciente?.tiempoPromedioHoras ?? 0;

    if (this.statCardsListas()) {
      this.actualizarStatCards();
    }
  }

  private procesarDatosConsumo(
    resumenMensual: IResumenDatosBase<'Consumo Mensual Luminarias'>[],
  ): void {
    // 1) Agrupar por mes (YYYY-MM) sumando consumos de distintos clientes hijos
    const agregadoPorMes = new Map<
      string,
      IResumenDatosBase<'Consumo Mensual Luminarias'>
    >();

    for (const item of resumenMensual || []) {
      if (!item?.periodoInicio) continue;
      const fecha = new Date(item.periodoInicio);
      const key = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)
        .toString()
        .padStart(2, '0')}`; // YYYY-MM

      const existente = agregadoPorMes.get(key);
      if (!existente) {
        agregadoPorMes.set(key, {
          periodoInicio: new Date(
            fecha.getFullYear(),
            fecha.getMonth(),
            1,
          ).toISOString(),
          resumen: {
            consumoTotal: item.resumen?.consumoTotal ?? 0,
            totalDispositivos: item.resumen?.totalDispositivos ?? 0,
          },
        } as IResumenDatosBase<'Consumo Mensual Luminarias'>);
      } else {
        existente.resumen = {
          consumoTotal:
            (existente.resumen?.consumoTotal ?? 0) +
            (item.resumen?.consumoTotal ?? 0),
          totalDispositivos:
            (existente.resumen?.totalDispositivos ?? 0) +
            (item.resumen?.totalDispositivos ?? 0),
        } as any;
      }
    }

    // 2) Ordenar por fecha de periodoInicio ascendente
    const listaAgregadaOrdenada = Array.from(agregadoPorMes.values()).sort(
      (a, b) => {
        const fa = new Date(a.periodoInicio!).getTime();
        const fb = new Date(b.periodoInicio!).getTime();
        return fa - fb;
      },
    );

    // 3) Filtrar por el rango de meses seleccionado en el date picker
    const mesesRango = this._getMesesEnRango(
      new Date(this.rangoMesesConsumo.start),
      new Date(this.rangoMesesConsumo.end),
    );

    const ultimos: IResumenDatosBase<'Consumo Mensual Luminarias'>[] =
      mesesRango.map((mes) => {
        const key = `${mes.getFullYear()}-${(mes.getMonth() + 1).toString().padStart(2, '0')}`;
        const existente = agregadoPorMes.get(key);
        if (existente) return existente;
        return {
          periodoInicio: mes.toISOString(),
          resumen: { consumoTotal: 0, totalDispositivos: 0 },
        } as IResumenDatosBase<'Consumo Mensual Luminarias'>;
      });

    // Preparar datos para el gráfico de columnas
    this.categoriasConsumo = ultimos.map((d) => {
      const fecha = new Date(d.periodoInicio!);
      const month = fecha.getMonth() + 1;
      const year = fecha.getFullYear();
      return `${month.toString().padStart(2, '0')}/${year}`;
    });

    const datosNumeros = ultimos.map((d) => {
      const v = d.resumen?.consumoTotal ?? 0;
      return Math.round(v * 100) / 100;
    });

    this.datosConsumo = [
      {
        name: 'Consumo',
        data: datosNumeros,
        color: ChartColors.color1(),
      },
    ];

    // Calcular consumo último mes para resumenes
    const ordenados = [...ultimos].sort((a, b) => {
      const fechaA = new Date(a.periodoInicio!);
      const fechaB = new Date(b.periodoInicio!);
      return fechaA.getTime() - fechaB.getTime();
    });

    let ultimo = ordenados[ordenados.length - 1];
    const hoy = new Date();
    const mesActual = hoy.getMonth() + 1;
    const anioActual = hoy.getFullYear();

    const fechaUltimo = new Date(ultimo.periodoInicio!);
    const esMesActual =
      fechaUltimo.getFullYear() === anioActual &&
      fechaUltimo.getMonth() + 1 === mesActual;

    if (
      esMesActual &&
      (ultimo.resumen?.consumoTotal ?? 0) === 0 &&
      ordenados.length > 1
    ) {
      ultimo = ordenados[ordenados.length - 2];
    }

    let diasParaDividir: number;
    const fechaUltimoFinal = new Date(ultimo.periodoInicio!);
    if (
      fechaUltimoFinal.getFullYear() === anioActual &&
      fechaUltimoFinal.getMonth() + 1 === mesActual
    ) {
      diasParaDividir = hoy.getDate();
    } else {
      diasParaDividir = new Date(
        fechaUltimoFinal.getFullYear(),
        fechaUltimoFinal.getMonth() + 1,
        0,
      ).getDate();
    }

    this.consumoUltimoMes =
      (ultimo.resumen?.consumoTotal ?? 0) / diasParaDividir;
    // Actualizar stat cards solo cuando todos los datos necesarios estén listos
    if (this.statCardsListas()) {
      this.actualizarStatCards();
      this.cargandoStatCards = false;
    }
  }

  public async onRangoMesesConsumoChange(rango: DateRangeValue): Promise<void> {
    this.rangoMesesConsumo = rango;
    await this.listarResumensMensualConsumo();
  }

  private _getMesesEnRango(start: Date, end: Date): Date[] {
    const meses: Date[] = [];
    const current = new Date(start.getFullYear(), start.getMonth(), 1);
    const endMonth = new Date(end.getFullYear(), end.getMonth(), 1);
    while (current <= endMonth) {
      meses.push(new Date(current));
      current.setMonth(current.getMonth() + 1);
    }
    return meses;
  }

  private procesarDatosCanales(uplinks: ILogEvento[]): void {
    // Agrupar por fecha y frecuencia para crear matriz de heatmap
    const conteoFechaFrecuencia: Record<string, Record<number, number>> = {};
    const todasLasFrecuencias = new Set<number>();

    uplinks.forEach((uplink) => {
      const frequency = uplink.metadatosUplink?.txInfo?.frequency;
      const fechaCreacion = uplink.fechaCreacion;

      if (frequency !== undefined && frequency !== null && fechaCreacion) {
        // Extraer solo la fecha (sin hora)
        const fecha = new Date(fechaCreacion).toLocaleDateString('es-AR', {
          day: '2-digit',
          month: 'short',
        });

        if (!conteoFechaFrecuencia[fecha]) {
          conteoFechaFrecuencia[fecha] = {};
        }
        if (!conteoFechaFrecuencia[fecha][frequency]) {
          conteoFechaFrecuencia[fecha][frequency] = 0;
        }
        conteoFechaFrecuencia[fecha][frequency]++;
        todasLasFrecuencias.add(frequency);
      }
    });

    // Ordenar fechas cronológicamente
    const fechasOrdenadas = Object.keys(conteoFechaFrecuencia).sort((a, b) => {
      const dateA = new Date(a.split(' ').reverse().join(' '));
      const dateB = new Date(b.split(' ').reverse().join(' '));
      return dateA.getTime() - dateB.getTime();
    });

    // Ordenar frecuencias de menor a mayor
    const frecuenciasOrdenadas = Array.from(todasLasFrecuencias).sort(
      (a, b) => a - b,
    );

    // Preparar categorías
    this.categoriasCanalesFechas = fechasOrdenadas;
    this.categoriasCanalesFrecuencias = frecuenciasOrdenadas.map((freq) =>
      (freq / 1000000).toLocaleString('es-AR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }),
    );

    // Crear datos para heatmap: [xIndex, yIndex, value]
    const heatmapData: [number, number, number][] = [];

    fechasOrdenadas.forEach((fecha, xIndex) => {
      frecuenciasOrdenadas.forEach((freq, yIndex) => {
        const valor = conteoFechaFrecuencia[fecha][freq] || 0;
        if (valor > 0) {
          heatmapData.push([xIndex, yIndex, valor]);
        }
      });
    });

    this.datosCanalesHeatmap = {
      data: heatmapData,
      name: 'Uplinks',
    };
  }

  private procesarDatosTiempoEncendido(): void {
    const conteo = {
      menos5000: 0,
      entre5000y10000: 0,
      mas10000: 0,
    };

    // Filtrar solo luminarias con dispositivo
    this.luminarias
      .filter((lum) => lum.deveui && lum.deveui.trim() !== '')
      .forEach((lum) => {
        const tiempo = lum.tiempoEncendida;
        if (!tiempo || tiempo < 5000) {
          conteo.menos5000++;
        } else if (tiempo <= 10000) {
          conteo.entre5000y10000++;
        } else {
          conteo.mas10000++;
        }
      });

    this.categoriasTiempoEncendido = ['< 5000h', '5000-10000h', '> 10000h'];

    this.datosTiempoEncendido = [
      {
        name: 'Cantidad de luminarias',
        data: [conteo.menos5000, conteo.entre5000y10000, conteo.mas10000],
        colors: [
          ChartColors.success(),
          ChartColors.warning(),
          ChartColors.error(),
        ],
      },
    ];
  }

  private procesarDatosCortes(): void {
    if (!this.cortesPorSemana?.dias || this.cortesPorSemana.dias.length === 0) {
      this.categoriasCortes = [];
      this.datosCortes = [];
      return;
    }

    // Ordenar días por fecha
    const diasOrdenados = [...this.cortesPorSemana.dias].sort((a, b) => {
      if (!a.dia || !b.dia) return 0;
      return new Date(a.dia).getTime() - new Date(b.dia).getTime();
    });

    // Extraer nombres de días y cantidad de luminarias con corte
    this.categoriasCortes = diasOrdenados.map((dia) => dia.nombreDia || '');

    const cantidades = diasOrdenados.map((dia) => dia.luminariasConCorte || 0);

    this.datosCortes = [
      {
        name: 'Luminarias con cortes',
        data: cantidades,
        color: ChartColors.error(), // Color rojo para indicar cortes
      },
    ];
  }

  private procesarDatosHeatmapCortes(): void {
    const points: [number, number][] = [];

    // Procesar cada día con cortes si existen (estructura original de OpenLayers)
    if (this.cortesPorSemana?.dias && this.cortesPorSemana.dias.length > 0) {
      this.cortesPorSemana.dias.forEach((dia) => {
        if (!dia.ubicaciones || dia.ubicaciones.length === 0) return;

        // Agregar cada luminaria afectada como un punto en el heatmap
        dia.ubicaciones.forEach((ubicacion) => {
          if (
            ubicacion.coordenadas?.coordinates &&
            ubicacion.coordenadas.coordinates.length === 2
          ) {
            // Mapbox usa [lon, lat] directamente (sin conversión de OpenLayers)
            const coord: [number, number] = [
              ubicacion.coordenadas.coordinates[0],
              ubicacion.coordenadas.coordinates[1],
            ];

            // Agregar el punto múltiples veces según la cantidad de cortes (mayor peso visual)
            const repeticiones = ubicacion.cantidadCortes || 1;
            for (let i = 0; i < repeticiones; i++) {
              points.push(coord);
            }
          }
        });
      });
    }

    // Convertir polígono del cliente si existe
    const polygons: any[] = [];
    let center: [number, number] | undefined = undefined;

    if (this.cliente?.poligono?.coordinates) {
      const allPoints: [number, number][] = [];

      this.cliente.poligono.coordinates.forEach((polygon) => {
        // Las coordenadas del polígono ya están en [lon, lat]
        const polygonCoords: any[] = polygon.map((ring) =>
          ring.map((point) => [point[0], point[1]]),
        );

        polygons.push({
          points: polygonCoords,
          color: 'rgba(59, 130, 246, 0.3)', // Azul semi-transparente
          centrar: false,
        });

        // Recolectar todos los puntos para calcular centro
        polygon.forEach((ring) => {
          ring.forEach((point) => {
            allPoints.push([point[0], point[1]]);
          });
        });
      });

      // Calcular centro como promedio
      if (allPoints.length > 0) {
        const avgX =
          allPoints.reduce((sum, p) => sum + p[0], 0) / allPoints.length;
        const avgY =
          allPoints.reduce((sum, p) => sum + p[1], 0) / allPoints.length;
        center = [avgX, avgY];
      }
    }

    // Si hay puntos de heatmap pero no centro calculado del polígono, calcular centro de los puntos
    if (points.length > 0 && !center) {
      const avgLng = points.reduce((sum, p) => sum + p[0], 0) / points.length;
      const avgLat = points.reduce((sum, p) => sum + p[1], 0) / points.length;
      center = [avgLng, avgLat];
    }

    // Si no hay puntos de cortes ni polígono, no mostrar nada
    if (points.length === 0 && polygons.length === 0) {
      this.datosHeatmapCortes = {};
      return;
    }

    this.datosHeatmapCortes = {
      heatmaps:
        points.length > 0
          ? [
              {
                points,
                blur: 25,
                radius: 20,
                gradient: ChartColors.getHeatmapGradient(), // Azul -> Verde -> Rojo
                opacity: 0.6,
                centrar: false,
              },
            ]
          : undefined,
      polygons: polygons?.length > 0 ? polygons : undefined,
      center: center, // Centrar en los puntos de calor o en el polígono del cliente
      zoom: 13, // Zoom adecuado para ver el área (reducido de 15 a 13 para ver más contexto)
      selectorBaseLayer: true,
    };
  }

  async ngOnInit(): Promise<void> {
    this.inicializarGraficos();

    await this.listar();

    await Promise.all([
      this.listarResumensMensualConsumo(),
      this.listarResumensDiarioEncendido(),
      this.obtenerReportes24h(),
      this.obtenerTasaEntrega(),
    ]);

    if (this.statCardsListas()) {
      this.actualizarStatCards();
      this.cargandoStatCards = false;
    }

    void this.listarCortesPorSemana();
    void this.listarUltimosUplinks();
    void this.listarAllUplinks();
    this.procesarDatosGraficos();
    this.procesarDatosTiempoEncendido();
  }
}
